export const environment = {
  production: false,
  apiURL: 'https://devapi.launch57.com/cbs/api',
  hubURL: 'https://devapi.launch57.com/cbs/community',
  baseUrl: 'https://qamanage.communibee.ca',
  clientRootUrl: 'https://qaexplore.communibee.ca/cbs',
  bbDashRootUrl: 'https://qaapp.bidbeacon.com',
  raffleDashRootUrl: 'https://qaadmin.raffle-rocket.com',
  raffleClientRootUrl: 'https://qago.raffle-rocket.com',
  raffleApiUrl: 'https://devapi.raffle-rocket.com/api',
};
